var image_viewer_rtlignore_default = {
  "fontElementMap": "eunVC",
  "imageContainer": "_0UA8Z",
  "expandContainer": "WBjuE",
  "expandIcon": "eWCLZ",
  "pointer": "xwhv5",
  "imageWrapper": "jaKIW",
  "imageRatio": "v67Y-",
  "image": "_2Ws1G",
  "imageOverlay": "XvJZa",
  "imagePreload": "oEHR8",
  "imageHighres": "vxcRR",
  "onlyHighRes": "C9XYA",
  "image_loading": "_0aEV9"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
